// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: icon('ic_user'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  folder: icon('ic_folder'),
  indicateurs: icon('ic_label'),
  tableau: icon('ic_menu_item'),
  external: icon('ic_external'),
  carbon: icon('ic_file'),
  history: icon('ic_menu_item'),
};

const navConfig = [
  {
    subheader: 'Général',
    items: [
      {
        title: 'Visualisation',
        path: PATH_DASHBOARD.charts.root,
        icon: ICONS.analytics,
        private: false,
      },
      {
        title: 'Aperçu global',
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
        private: true,
      },
      {
        title: 'Programme et volets',
        path: PATH_DASHBOARD.general.programVolets,
        icon: ICONS.external,
      },
    ],
  },

  {
    subheader: 'Gestion',
    items: [
      {
        title: 'Base de données',
        path: PATH_DASHBOARD.folder.list,
        icon: ICONS.folder,
      },
      {
        title: "Suivi d'activités",
        path: PATH_DASHBOARD.activity.root,
        icon: ICONS.tableau,
      },
      {
        title: 'Suivi des indicateurs',
        path: PATH_DASHBOARD.indicators.root,
        icon: ICONS.indicateurs,
      },
      {
        title: 'Comptabilité carbone',
        path: PATH_DASHBOARD.carbon.root,
        icon: ICONS.carbon,
        // private: true,
      },
      // {
      //   title: 'Statistiques Climatiques',
      //   path: PATH_DASHBOARD.carbonStats.root,
      //   icon: ICONS.analytics,
      //   private: true,
      // },

      {
        title: 'Utilisateurs',
        path: PATH_DASHBOARD.user.list,
        icon: ICONS.user,
        private: true,
      },
      {
        title: 'Activités des utilisateurs',
        path: PATH_DASHBOARD.history.root,
        icon: ICONS.history,
        private: true,
      },
    ],
  },
];

export default navConfig;
